// YouTube facade: swaps the poster button rendered by
// resources/views/components/frontend/youtube.blade.php for the real
// player iframe on click. Styles: resources/frontend/scss/components/_video-block.scss
import $ from 'jquery';

$(document).on('click', '[data-youtube-facade]', function () {
    const $facade = $(this);

    $('<iframe>', {
        class: 'video-block__iframe',
        src: $facade.data('src'),
        title: $facade.data('title') || '',
        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
        allowfullscreen: true,
    }).replaceAll($facade);
});
